module.exports = __webpack_public_path__ + "img/photo_bg.dd68ba31.png";